import type { CSSProperties } from 'react';

export const EDR_COLORS = {
  textPrimary: '#1A202C',
  textHeading: '#1E293B',
  textBody: '#4A5568',
  textSecondary: '#718096',
  textMuted: '#A0AEC0',
  borderDefault: '#EDF2F7',
  borderSubtle: '#F1F5F9',
  borderStrong: '#CBD5E0',
  bgSurface: '#FFFFFF',
  bgHover: '#F7FAFC',
  brand50: '#EBF8FF',
  brand200: '#BEE3F8',
  brand500: '#3182CE',
  brand600: '#2B6CB0',
  brand700: '#2C5282',
  success: '#15803D',
  successBg: '#DCFCE7',
  critical: '#DC2626',
  criticalBg: '#FEE2E2',
  high: '#DD6B20',
  highBg: '#FEEBC8',
  medium: '#B45309',
  mediumBg: '#FEF3C7',
  low: '#15803D',
  lowBg: '#DCFCE7',
  slate50: '#F8FAFC',
  slate100: '#F1F5F9',
  slate200: '#E2E8F0',
  slate500: '#64748B',
  slate700: '#334155',
} as const;

export type EdrSeverityLevel = 'critical' | 'high' | 'medium' | 'low' | 'informational';

export const SEVERITY_TONES: Record<
  EdrSeverityLevel,
  { color: string; bg: string; label: string }
> = {
  critical: { color: '#DC2626', bg: '#FEE2E2', label: 'Critical' },
  high: { color: '#DD6B20', bg: '#FEEBC8', label: 'High' },
  medium: { color: '#B45309', bg: '#FEF3C7', label: 'Medium' },
  low: { color: '#15803D', bg: '#DCFCE7', label: 'Low' },
  informational: { color: '#64748B', bg: '#F1F5F9', label: 'Informational' },
};

export type EdrStatusTone =
  | 'critical'
  | 'high'
  | 'medium'
  | 'success'
  | 'brand'
  | 'neutral';

export const STATUS_TONES: Record<EdrStatusTone, { color: string; bg: string }> = {
  critical: { color: '#DC2626', bg: '#FEE2E2' },
  high: { color: '#DD6B20', bg: '#FEEBC8' },
  medium: { color: '#B45309', bg: '#FEF3C7' },
  success: { color: '#15803D', bg: '#DCFCE7' },
  brand: { color: '#2B6CB0', bg: '#EBF8FF' },
  neutral: { color: '#475569', bg: '#E2E8F0' },
};

export const edrCardSx = {
  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.06)',
  border: `1px solid ${EDR_COLORS.borderDefault}`,
  borderRadius: '8px',
  backgroundColor: EDR_COLORS.bgSurface,
} as const;

export const edrMonoStyle: CSSProperties = {
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
};

export const edrMutedStyle: CSSProperties = {
  color: EDR_COLORS.textSecondary,
  fontStyle: 'italic',
};
